export class Credit {
  id: number;
  name: string;
  
  constructor(data) {
    this.id = parseInt(data.credit_id);
    this.name = data.name;
  }
}
